(function () {
  document.querySelectorAll('.sheluxe-landing .faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var answer = item.querySelector('.faq-a');
      var plus = btn.querySelector('.plus');
      var isHidden = answer.hasAttribute('hidden');

      item.parentElement.querySelectorAll('.faq-item').forEach(function (other) {
        if (other !== item) {
          other.querySelector('.faq-a').setAttribute('hidden', '');
          other.querySelector('.plus').classList.remove('open');
        }
      });

      if (isHidden) {
        answer.removeAttribute('hidden');
        plus.classList.add('open');
      } else {
        answer.setAttribute('hidden', '');
        plus.classList.remove('open');
      }
    });
  });

  function updateCartCount(count) {
    document
      .querySelectorAll(
        '[data-cart-count], .cart-count, .cart-count-bubble, #CartCount, #cart-icon-bubble .cart-count-bubble span'
      )
      .forEach(function (el) {
        el.textContent = count;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.sheluxe-landing [data-buy-now-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();

    var btn = form.querySelector('[data-buy-now-btn]');
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not add to cart');
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.sheluxe-landing [data-add-to-cart-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();

    var btn = form.querySelector('[data-add-to-cart-btn]');
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not add to cart');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        btn.textContent = 'Added ✓';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        }, 1800);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Error, try again';
        setTimeout(function () {
          btn.textContent = originalText;
        }, 1800);
      });
  }, true);
})();
